module.exports = __webpack_public_path__ + "static/media/bg4.cd2a55b6.jpg";